import { useEffect, useRef } from 'react';

import { UnpaidOrdersNotify } from '@components/UnpaidOrdersNotify';
import { useUnpaidOrdersList } from '@hook/useUnpaidOrdersList';
import { useSmartPlans } from '@hook/useSmartPlans';

type OnInitialLoadArg = {
  isEmptyResult: boolean
};

type Props = {
  onInitialLoad?: (arg: OnInitialLoadArg) => void
  className?: string
};

export const UnpaidOrdersNotifyContainer: React.FC<Props> = ({
  onInitialLoad,
  className,
}) => {
  const { orders, ignore, loading: ordersLoading } = useUnpaidOrdersList();
  const { plans, loading: plansLoading } = useSmartPlans();

  const initialLoadRef = useRef(false);
  useEffect(() => {
    if (!ordersLoading) {
      if (!initialLoadRef.current) {
        onInitialLoad?.({ isEmptyResult: !orders.length });
      }
      initialLoadRef.current = true;
    }
  }, [ordersLoading, orders, onInitialLoad]);

  if (!orders?.length) {
    return null;
  }

  const currentOrder = orders[0];
  const smartPlan = plans.find((plan) => plan.planId === currentOrder?.smartPlanId);

  return (
    <UnpaidOrdersNotify
      className={className}
      order={currentOrder}
      smartPlan={smartPlan}
      loading={plansLoading}
      onClose={() => ignore(currentOrder.id)}
    />
  );
};
